import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Alert, Button, InputLabel, MenuItem, Select, Paper } from '@mui/material';
import { useState } from 'react';
import axios from 'axios';
import { api_url } from '../config';
import { useEffect } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';


function preventDefault(event) {
  event.preventDefault();
}

export default function Deposits({ token, fetch }) {

  const [sow, setSow] = useState("");
  const [load, setLoad] = useState(false);
  const [msg,setMsg] = useState(false);
  const [disable,setDisable] = useState(false);
  const [error, setError] = useState(false);
 
   
  const handleClick = async () => {
    try {
      if(sow.length == 0){
        setError(true);
      }
      else{
        setError(false);
      }
      setLoad(true);
      let id = localStorage.getItem('id')
      const { data: obj } = await axios({
        url: api_url + '/mission-vriksh-place-order',
        method: 'post',
        responseType: 'json',
        data: {
          id: token,
          sow: sow,
        }
      })

      if (obj.success === 'ok') {
        setMsg(true);
        // alert("Trees Planted")
        setTimeout(()=>{
          fetch(token);
        },3000)
        setDisable(true);
      }

    }
    catch (e) {
      alert(e.message);
    }
    finally {
      setLoad(false);
    }
  }

  return (
    <React.Fragment>

      <Typography style={{ textAlign: 'center' }} variant="h5">Adopt A Tree</Typography>

      <br />


      <Paper style={{ padding: '10px', backgroundColor: 'seashell' }}>
        <InputLabel>Select No.of Trees to be Planted</InputLabel>
        <Select value={sow} onChange={(e) => setSow(e.target.value)} label="Select" fullWidth 
       
        >
          <em>Select No. of Trees to be Planted</em>
          <MenuItem value="1">1</MenuItem>
          <MenuItem value="2">2</MenuItem>
          <MenuItem value="3">3</MenuItem>
          <MenuItem value="4">4</MenuItem>
          <MenuItem value="5">5</MenuItem>
          <MenuItem value="6">6</MenuItem>
          <MenuItem value="7">7</MenuItem>
          <MenuItem value="8">8</MenuItem>
          <MenuItem value="9">9</MenuItem>
          <MenuItem value="10">10</MenuItem>
          <MenuItem value="11">11</MenuItem>
          <MenuItem value="12">12</MenuItem>
          <MenuItem value="13">13</MenuItem>
          <MenuItem value="14">14</MenuItem>
          <MenuItem value="15">15</MenuItem>
          <MenuItem value="16">16</MenuItem>
          <MenuItem value="17">17</MenuItem>
          <MenuItem value="18">18</MenuItem>
          <MenuItem value="19">19</MenuItem>
          <MenuItem value="20">20</MenuItem>
        </Select>
        <br /><br />
        <Button style={{ backgroundColor: '#b11116', color: '#FFFFFF' }} fullWidth onClick={handleClick} disabled={disable}>Submit</Button>
        <br />
      </Paper>
      {load && <Alert severity='error'>...Loading</Alert>}
      {msg && <p style={{color:'#b11116',marginTop:"20px",textAlign:'center'}}>Trees Adopted</p>}
      {error && <Alert severity='error'>Please Select Trees to Adopt</Alert>}
    </React.Fragment>
  );
}